const translations = {
  PRIMARY_BALANCE: 'Tài khoản chính',
  SECONDARY_BALANCE: 'Tài khoản phụ',
  PAYMENT: 'Nạp tiền',
  HISTORY: 'Lịch sử',
  BALANCE: 'Tài khoản'
};

export default translations;
